export const SET_TIMEOUT_ID = "SET_TIMEOUT_ID";
export const REGISTER_ACTIVITY = "REGISTER_ACTIVITY";
export const REGISTER_MENU_ACTIVITY = "REGISTER_MENU_ACTIVITY";
